import LegalPage from "@/components/legal/LegalPage";

const H2 = {
  color: '#f7f7f7',
  fontSize: 18,
  fontWeight: 700,
  marginTop: 24,
  marginBottom: 10,
  letterSpacing: '0.2px'
};

const H3 = {
  color: '#f7f7f7',
  fontSize: 15,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: 8,
  letterSpacing: '0.2px'
};

const A = {
  color: '#C9A86A',
  textDecoration: 'underline'
};

export default function About() {
  return (
    <LegalPage title="About CDI Collectables" testid="page-about">
      <>
        <h2 style={H2}>Why I Built CDI Collectables</h2>
        <p>I built CDI Collectables because I wanted one place to track and manage my collections, understand their worth, and keep records of all purchases and sales.</p>

        <h2 style={H2}>About CDI Collectables</h2>
        <p>CDI Collectables is a portfolio management app designed for collectors who want a clean, structured way to organise their collections, track item details, and understand the value and performance of their portfolio.</p>

        <h2 style={H2}>Regional Availability</h2>
        <p>CDI Collectables is available in selected regions. The app is not available for use in the United Kingdom or the European Union. This restriction is due to regulatory and compliance requirements specific to those jurisdictions.</p>

        <h2 style={H2}>What the App Does</h2>
        <p>The app helps you manage collections, categories, and items; upload photos; track purchase details; record sales; and view analytics across your entire portfolio. All data is stored securely in the cloud.</p>

        <h2 style={H2}>Who the App Is For</h2>
        <p>CDI Collectables is built for collectors who want a simple, reliable way to organise their items, maintain accurate records, and monitor performance without spreadsheets or manual tracking.</p>

        <h2 style={H2}>Key Features</h2>
        <p>Structured collections</p>
        <p>Customisable categories</p>
        <p>Detailed item tracking</p>
        <p>Photos for items and categories</p>
        <p>Dashboard analytics per collection</p>
        <p>Portfolio-wide financial insights</p>
        <p>Sales history and realised performance</p>
        <p>Secure cloud storage</p>

        <h2 style={H2}>Contact</h2>
        <p>For support, contact: <a href="mailto:support@cdicollectables.co.nz" style={A}>support@cdicollectables.co.nz</a></p>
      </>
    </LegalPage>
  );
}
